import * as React from 'react';
import makeIcon from './make_icon';
import { jsx as ___EmotionJSX } from "@emotion/core";
var roundFilled = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.3536 4.14645C15.5488 4.34171 15.5488 4.65829 15.3536 4.85355L8.20711 12L15.3536 19.1464C15.5488 19.3417 15.5488 19.6583 15.3536 19.8536C15.1583 20.0488 14.8417 20.0488 14.6464 19.8536L7.14645 12.3536C6.95118 12.1583 6.95118 11.8417 7.14645 11.6464L14.6464 4.14645C14.8417 3.95118 15.1583 3.95118 15.3536 4.14645Z"
});
var roundLined = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.3536 4.14645C15.5488 4.34171 15.5488 4.65829 15.3536 4.85355L8.20711 12L15.3536 19.1464C15.5488 19.3417 15.5488 19.6583 15.3536 19.8536C15.1583 20.0488 14.8417 20.0488 14.6464 19.8536L7.14645 12.3536C6.95118 12.1583 6.95118 11.8417 7.14645 11.6464L14.6464 4.14645C14.8417 3.95118 15.1583 3.95118 15.3536 4.14645Z"
});
var sharpFilled = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.7071 4.70027L8.4071 12.0003L15.7071 19.3003L15 20.0074L6.99289 12.0003L15 3.99316L15.7071 4.70027Z"
});
var sharpLined = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.7071 4.70027L8.4071 12.0003L15.7071 19.3003L15 20.0074L6.99289 12.0003L15 3.99316L15.7071 4.70027Z"
});
var IconChevronLeft = makeIcon('IconChevronLeft', 'Chevron Left', false, {
  roundFilled,
  roundLined,
  sharpFilled,
  sharpLined
});
export default IconChevronLeft;